import { takeEvery } from 'redux-saga/effects';
import {
  getQcsSyncResources,
  qcsSyncUpdateResource,
} from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';
import * as actions from './actions';
import { getLastSyncDate } from './selectors';
import {
  transformAlertRulesToRequestData,
  transformResponseToAlertRules,
} from './transformers';


const mkResourceConfig = (successAction, failureAction) => mkQcsSyncResourceConfig({
  resourceName: 'alertRule',
  resourceBaseUrl: '/alert/alert-rules',
  getLastSyncDate,
  transformResponseToResources: transformResponseToAlertRules,
  transformResourceToRequestData: transformAlertRulesToRequestData,

  successAction,
  failureAction,
});

export function* getAlertRulesActionWatcher() {
  // using a vanilla saga pattern so we only process a single get request
  //   - takeEvery would process every request
  //   - takeLatest would cancel any current request and start request again
  yield takeEvery(actions.getAlertRules, getQcsSyncResources, mkResourceConfig(actions.getAlertRulesSuccess, actions.getAlertRulesFailure));
}

export function* updateAlertRulesActionWatcher() {
  const config = mkResourceConfig(actions.updateAlertRulesSuccess, actions.updateAlertRulesFailure);
  yield takeEvery(actions.updateAlertRules, qcsSyncUpdateResource, config);
}

export default [
  updateAlertRulesActionWatcher,
  getAlertRulesActionWatcher,
]
